import './infrastructure.scss';
import React, { useEffect, useRef, useState } from 'react';
import AppelerApi from '../../../services/appeler-api.service';
import websocketService from '../../../services/websocket.service';
import { Button } from '@mui/material';
import Select from 'react-select';
import notificationService from '../../../services/notification.service';

const Infrastructure = () => {

    const [valeurEntree, _] = useState('');
    let [vms, setVms] = useState([]);
    let [optionsBranches, setOptionsBranches] = useState({});
    const vmsAJour = useRef();
    vmsAJour.current = vms;

    const modifierBranche = (vmModifiee, nouvelleBranche) => {
        setVms(vmsPrecedentes => {
            for (const vm of vmsPrecedentes) {
                if (vm.IDBuild_Configuration === vmModifiee.IDBuild_Configuration) {
                    vm.Branche_Selectionnee = nouvelleBranche;
                    break;
                }
            }
            return vmsPrecedentes;
        });
    };

    const deployerBranche = (vm) => {
        return (_) => {
            AppelerApi.post('/deployer-branche', { id: vm.IDBuild_Configuration, branche: vm.Branche_Selectionnee }).then(() => {});
        };
    };

    const afficherStatutDeploiement = (vm) => {
        switch (vm.Statut) {
            case 0: return 'déploiement demandé';
            case 1: return 'déploiement lancé';
            case 2: return 'déploiement réussi';
            case 3: return 'build échoué';
            case 4: return 'déploiement échoué';
            case 5: return 'nouvel essai';
            case 6: return 'déploiement annulé';
        }
        return 'inconnu';
    };

    const lireVmsDeployees = () => {
        AppelerApi.get('/lire-vm-deployees').then(listeVms => {
            setVms(listeVms);
            for (const vm of listeVms) {
                AppelerApi.post('/lire-branches-git', { depotGit: vm.Depot_Git }).then(listeBranches => {
                    const nouvellesOptions = {};
                    nouvellesOptions[vm.IDBuild_Configuration] = listeBranches.map(branche => { return {value: branche, label: branche}; });
                    setOptionsBranches(optionsPrecedentes => { return {...optionsPrecedentes, ...nouvellesOptions }; });
                });
            }
        });
    };

    const majStatutInfrastructure = (donnees) => {
        const listeVms = JSON.parse(JSON.stringify(vmsAJour.current));
        for (const vm of listeVms) {
            if (vm.Nom_Pipeline === donnees.nomPipeline) {
                vm.Statut = donnees.statut;
                notificationService.afficher(`${vm.Nom} ${afficherStatutDeploiement(vm)}`, `${vm.Nom} ${afficherStatutDeploiement(vm)}`);
            }
        }
        setVms(listeVms);
    };

    useEffect(() => {
        websocketService.connecterWebSocket(true);
        websocketService.enregistrerFonction('majStatutInfrastructure', majStatutInfrastructure);
        lireVmsDeployees();
    }, [valeurEntree]);

    return (
        <div className="conteneur-infrastructure">
            <h1>Déploiement dans l'infrastructure</h1>
            <div className="bloc-fonctionnel">
                {(<div className="tableau-vms">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col">Application</th>
                                <th scope="col">Branche</th>
                                <th scope="col">Statut</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.values(vms).map(vm =>
                                <tr key={vm.IDBuild_Configuration} className="ligne-vm">
                                    <td>{vm.Nom}</td>
                                    <td>
                                        {(optionsBranches[vm.IDBuild_Configuration] &&
                                        <Select
                                            defaultValue={optionsBranches[vm.IDBuild_Configuration].find(option => option.value == vm.Branche_Selectionnee)}
                                            options={optionsBranches[vm.IDBuild_Configuration]}
                                            onChange={e => modifierBranche(vm, e.value)}
                                            className="selection-branche"
                                        />
                                        )}
                                    </td>
                                    <td>
                                        {afficherStatutDeploiement(vm)}
                                    </td>
                                    <td>
                                        <Button onClick={deployerBranche(vm)}>Déployer</Button>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>)}
            </div>
        </div>
    );
};

export default Infrastructure;